<template>
  <div>
    <div class="task-actions mb-3">
      <div class="task-memo">
        <div class="mr-3 d-flex align-content-center align-items-center">
          <div
            class="task-tags tags-rounded-icon tags-style-bg-order_id d-flex"
          ></div>
          <div><span class="text-secondary ml-2">Заказ</span></div>
        </div>
        <div class="mr-3 d-flex align-content-center align-items-center">
          <div
            class="task-tags tags-rounded-icon tags-style-bg-company_id"
          ></div>
          <div><span class="text-secondary ml-2">Компания</span></div>
        </div>
        <div class="mr-3 d-flex align-content-center align-items-center">
          <div class="task-tags tags-rounded-icon tags-style-bg-order_service_id"></div>
          <div><span class="text-secondary ml-2">Услуга</span></div>
        </div>
        <div class="mr-3 d-flex align-content-center align-items-center">
          <div
            class="task-tags tags-rounded-icon tags-style-bg-finance_id"
          ></div>
          <div><span class="text-secondary ml-2">Финансы</span></div>
        </div>
        <div class="mr-3 d-flex align-content-center align-items-center">
          <div
            class="task-tags tags-rounded-icon tags-style-bg-notification"
          ></div>
          <div><span class="text-secondary ml-2">Напоминание</span></div>
        </div>
      </div>
      <div class="task-button">
        <div class="mr-3">
          <b-button
            @click="refreshDataInTasks()"
            size="sm"
            variant="outline-blue"
            id="context-menu"
          >
            <b-icon
              icon="arrow-repeat"
              scale="1.5"
              aria-label="Reload"
              :animation="isTaskRefreshing ? 'spin' : ''"
            ></b-icon>
          </b-button>
        </div>
        <div>
          <button
            class="btn btn-outline-blue"
            @click="openCreateTaskSidebar"
          >Создать задачу</button>
        </div>
      </div>
    </div>

    <!-- <h5 class="mb-2">Поиск по задачам и выбор пользователя</h5> -->
    <div class="task-select-user-wrapper mb-4">
      <b-form-input
        v-model="search_text"
        placeholder="Поиск по задачам..."
        debounce="500"
        type="search"
        class="mr-3"
      />

      <tsoft-select-user
        id="user-tasks"
        :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||administrator||bsz-manager||b2c-head-manager||b2c-manager||lawyer-manager||lawyer-head-manager||hr-manager||hr-head-manager||agent`"
        :needNullElement="true"
        :needAllElement="true"
        :selected="currentUser.id"
        style="width: 220px; min-width: 220px;"
        @set="setUserId"
      />
    </div>

    <h5 class="mt-4">Задачи на выполнение</h5>
    <div class="tasks-wrapper">
      <div class="col" v-for="column in columns" :key="column.title">
        <div class="task-title-block shadow-sm mb-3">
          <p class="text-uppercase mb-0">{{ column.title }}</p>
          <span>{{ column.meta ? column.meta.total : '' }}</span>
        </div>
        <draggable
          class="task-list-block"
          :list="column.tasks"
          :animation="300"
          ghost-class="ghost-card"
          group="tasks"
          @change="update($event, column.key)"
        >
          <tsoft-task
            v-for="task in column.tasks"
            :key="task.id"
            :task="task"
            class="task-block mb-2 cursor-move shadow-sm p-2"
          />
          <Observer
            v-if="observerView(column)"
            @intersect="pagination(column)"
          />
        </draggable>
      </div>
    </div>

    <CreateTaskWidget
      @setNewCreatedTask="setNewCreatedTask"
      @openCreateTaskSidebar="openCreateTaskSidebar"
    />
  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import TaskCard from '@/components/task/Task.vue';
import CreatedAndPersonalTaskCard from '@/components/task/CreatedAndPersonalTask.vue';
import Observer from '@components/observer/Observer';
import CreateTaskWidget from '@/components/task/CreateTaskWidget.vue';

import { API_TASKS, API_UPDATE_TASKS, API_USER_TASKS } from '@/constants';

import { defaultDataItems } from '@/mixins';
import { openCreateTaskSidebar } from '@/mixins/openTasksSidebar';
import { mapGetters } from 'vuex';

const columns = [
{
  title: 'К выполнению',
  key: 'to-work',
  tasks: [],
  reference_status_id: 400,
},
{
  title: 'В работе',
  key: 'on-work',
  tasks: [],
  reference_status_id: 401,
},
{
  title: 'На проверке',
  key: 'on-check',
  tasks: [],
  reference_status_id: 402,
},
{
  title: 'Выполнено',
  key: 'done',
  tasks: [],
  reference_status_id: 403,
}]

export default {
  components: {
    Draggable,
    "tsoft-task": TaskCard,
    "tsoft-created-and-personal-task": CreatedAndPersonalTaskCard,
    Observer,
    CreateTaskWidget,
  },
  mixins: [
    defaultDataItems,
    openCreateTaskSidebar,
  ],
  data() {
    return {
      isTaskRefreshing: false,
      taskColumn: [],
      columns: JSON.parse(JSON.stringify(columns)),
      search_text: '',
      calendarUserId: null,
    };
  },
  watch: {
    'calendarUserId'() {
      this.columns = JSON.parse(JSON.stringify(columns));
      this.columns.forEach(col => this.getTaskList(null, col.reference_status_id))
    },
    'search_text'() {
      this.columns = JSON.parse(JSON.stringify(columns));
      this.columns.forEach(col => this.getTaskList(null, col.reference_status_id))
    },
    GET_TASK: {
      handler(task) {
        const indexCol = this.columns.findIndex(c => c.reference_status_id === task.reference_status_id);
        const indexTask = this.columns[indexCol].tasks.findIndex(t => t.id === task.id);

        if (indexTask !== -1) {
          Object.assign(this.columns[indexCol].tasks[indexTask], task);
        } else {
          this.columns.forEach(col => {
            const indexOldTask = col.tasks.findIndex(t => t.id === task.id);
            if (indexOldTask !== -1) {
              col.tasks.splice(indexOldTask, 1)
            }
          })
          this.columns[indexCol].tasks.unshift(task);
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser']),
    ...mapGetters('task', ['GET_TASK']),
  },
  mounted() {
    this.columns.forEach(col => this.getTaskList(null, col.reference_status_id))
  },
  methods: {
    //При созданий новой задачи, обновляем список
    setNewCreatedTask(createdTask) {
      this.columns[0].tasks.unshift(createdTask);
      this.columns[0].meta.total += 1;
      this.getTaskList(null, this.columns[0].reference_status_id)
    },
    //Обновление списка задач
    refreshDataInTasks() {
      this.isTaskRefreshing = true;
      this.columns = JSON.parse(JSON.stringify(columns));
      this.columns.forEach(col => this.getTaskList(null, col.reference_status_id));
    },
    //Событие update при переносе задач между колоннами, moved внутри колонны
    update(e, type) {
      if (e.added) {
        let element = e.added.element;
        if (type == 'to-work') {
          this.sortingTasks(0, 400, element);
        }
        if (type == 'on-work') {
          this.sortingTasks(1, 401, element);
        }
        if (type == 'on-check') {
          this.sortingTasks(2, 402, element);
        }
        if (type == 'done') {
          this.sortingTasks(3, 403, element);
        }
      }
      if (e.moved) {
        if (type == 'to-work') {
          this.sortingTasks(0, 400);
        }
        if (type == 'on-work') {
          this.sortingTasks(1, 401);
        }
        if (type == 'on-check') {
          this.sortingTasks(2, 402);
        }
        if (type == 'done') {
          this.sortingTasks(3, 403);
        }
      }
    },
    //Обновление личного статуса задачи у пользователя
    sortingTasks(columnIndex, status = null, element = null) {
      const index = element.reference_status_id;

      function handlerTypeColumns(status) {
        if (status == '400') {
          return 'на выполнении';
        }
        if (status == '401') {
          return 'в работе';
        }
        if (status == '402') {
          return 'на проверке';
        }
        if (status == '403') {
          return 'выполнена';
        }
      }

      if (element != null) {
        for (let i = 0; i < element.realizators.length; i++) {
          if (
            element.realizators[i].pivot.realizator_user_id ==
            this.currentUser.id
          ) {
            let realizatorItem = {
              reference_status_id: status,
            };
            api
              .call(
                'put',
                `${API_USER_TASKS}/${element.realizators[i].pivot.id}`,
                realizatorItem
              )
              .then(({ data }) => {
                this.makeToast(
                  'success',
                  `Задача #${
                    element.realizators[i].pivot.task_id
                  } ${handlerTypeColumns(data.reference_status_id)}`
                );
              });
          }
        }
      }

      let taskArray = [];

      for (let taskIndex in this.columns[columnIndex].tasks) {
        let taskData = {
          task_id: this.columns[columnIndex].tasks[taskIndex].id,
          ordering_number: taskIndex,
          reference_status_id: this.columns[columnIndex].reference_status_id,
        };

        taskArray.push(taskData);
      }

      this.updateOneTask(taskArray, columnIndex, index);
    },
    updateOneTask(tasksArray, columnIndex, oldIndex) {
      api
        .call('post', API_UPDATE_TASKS, { params: tasksArray })
        .then(({ data }) => {
          let getUpdateTasks = [];

          const id = this.columns.findIndex(c => c.reference_status_id === oldIndex);
          this.columns[id].meta.total -= 1;
          this.columns[id].meta.to -= 1;
          this.columns[columnIndex].meta.total += 1;
          this.columns[columnIndex].meta.to += 1;

          function byField(field) {
            return (a, b) => (a[field] > b[field] ? 1 : -1);
          }

          for (let i = 0; i < data.length; i++) {
            getUpdateTasks.push(data[i]);
            if (i + 1 === data.length) {
              getUpdateTasks.sort(byField('ordering_number'));
            }
          }

          for (let taskColumn in this.columns) {
            if (columnIndex == taskColumn) {
              this.columns[taskColumn].tasks = getUpdateTasks;
              break;
            }
          }
        });
    },
    getTaskList(newParams, status) {
      let search_params = '';
      let user_id = '';

      if (this.search_text) {
        search_params = `&q=${this.search_text}`
      }

      if (this.calendarUserId) {
        user_id = this.calendarUserId
      } else if (this.calendarUserId === null) {
        user_id = this.currentUser.id
      } else {
        user_id = 'all'
      }

      let status_params = `&reference_status_id=${status}`

      let pageParams = '&per_page=10&page=1';

      if (newParams) {
        pageParams = `&per_page=${newParams.per_page}&page=${newParams.page}`
      }

      let getParam = `?user_id=${user_id}${status_params}${pageParams}${search_params}`;
      api.call('get', `${API_TASKS}/${getParam}`)
        .then(({ data }) => {
          let index = this.columns.findIndex(i => i.reference_status_id === status);

          data.data.forEach(task => {
            if (!this.columns[index].tasks.length) {
              this.columns[index].tasks.push(task)
            } else {
              if (this.columns[index].tasks.findIndex(t => t.id === task.id) === -1) {
                this.columns[index].tasks.push(task)
              }
            }
          })

          this.columns[index].meta = {
            to: data.to,
            total: data.total,
            per_page: data.per_page,
            page: data.current_page,
          }

          // then update tasklist last status off refresh
          if (status === 403) {
            this.isTaskRefreshing = false;
          }
      })
    },
    setUserId(id) {
      this.calendarUserId = id
    },
    observerView(column) {
      if (!column.meta) return false

      if (!!column.meta.to === false) {
        return false;
      } else {
        return column.meta.to !== column.meta.total;
      }
    },
    async pagination(column) {
      await this.getTaskList({
        page: ++column.meta.page,
        per_page: column.meta.per_page,
      }, column.reference_status_id);
    },
  },
};
</script>
